import Vue from 'vue';
import Router from 'vue-router';
import Debug from '@/util/debug';
import Login from '@/components/login/Login.vue';
import CampaignWrapper from '@/components/campaign-wrapper/CampaignWrapper.vue';
import CampaignSetup from '@/components/campaign-setup/CampaignSetup.vue';
import CampaignTarget from '@/components/campaign-target/CampaignTarget.vue';
import CampaignOffer from '@/components/campaign-offer/CampaignOffer.vue';
import CampaignFormat from '@/components/campaign-format/CampaignFormat.vue';
import CampaignSettings from '@/components/campaign-settings/CampaignSettings.vue';
import CampaignCheckout from '@/components/campaign-checkout/CampaignCheckout.vue';
import Proposal from '@/components/proposal/Proposal.vue';
import Proposals from '@/components/proposals-remote/ProposalsRemote.vue';
import Examples from '@/components/examples/Examples.vue';
import NotFound from '@/components/not-found/NotFound.vue';
import inject from '@/util/inject';
import * as LocalStorage from '@/util/local-storage';
import { setPrefillData } from '@/util/prefill';

const debug = Debug('router');

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    { path: '/login', name: 'login', component: Login },

    {
      path: '/campaign/:id',
      name: 'campaign-wrapper',
      component: CampaignWrapper,
      children: [
        { path: 'setup', name: 'campaign-setup', component: CampaignSetup },
        { path: 'target', name: 'campaign-target', component: CampaignTarget },
        { path: 'offer', name: 'campaign-offer', component: CampaignOffer },
        { path: 'format', name: 'campaign-format', component: CampaignFormat },
        { path: 'settings', name: 'campaign-settings', component: CampaignSettings },
        { path: 'checkout', name: 'campaign-checkout', component: CampaignCheckout },
      ],
    },

    { path: '/campaign', name: 'campaign-new', redirect: '/campaign/new' },
    { path: '/', name: 'home', redirect: '/campaign' },

    { path: '/proposal/:id', name: 'proposal', component: Proposal },
    { path: '/proposals/:tab?', name: 'proposals', component: Proposals },

    { path: '/examples/:tab?', name: 'examples', component: Examples },

    { path: '*', name: 'not-found', component: NotFound },
  ],
});

let visited = false;
router.beforeEach((to, from, next) => {
  // TODO - this is bad, we shouldn't manually inject.get, Vuex will fix this
  const as = inject.get('authService', { $context: router.app });

  if (!visited) {
    // Prefill campaign draft data
    setPrefillData(to.query);
    visited = true;
  }

  // Redirect non-authorized users to /login
  if (to.name !== 'login' && to.name !== 'not-found' && !as.getUser()) {
    debug.info('redirecting non-authed user to /login');
    return LocalStorage.set('router:last', to.fullPath)
      .then(() => next(to.query.lang ? `/login?lang=${to.query.lang}` : '/login'));
  }

  debug.info('opening %s (%s) params: %j', to.name, to.path, to.params);
  inject.get('titleService').refreshTitle();

  // Change proposal tab according to draft status
  if (to.name === 'proposals' && !to.params.tab) {
    if (from.name === 'campaign-checkout') {
      return next({ name: 'proposals', params: { tab: 'checkout' } });
    }

    if (from.name === 'proposal') {
      return next({ name: 'proposals', params: { tab: 'completed' } });
    }
  }

  return next();
});

router.afterEach(to => {
  debug.info('navigated to %s', to.fullPath);
  inject.get('titleService').refreshTitle();
  if (to.name !== 'login') {
    return LocalStorage.set('router:last', to.fullPath);
  }
  return Promise.resolve();
});

export default router;



// WEBPACK FOOTER //
// ./src/state/router.js